/** @typedef {{ category: string, gender: string, eu: string, uk: string, us: string, cm: string }} ShoeSizeRow */

/** @type {ShoeSizeRow[]} */
export const menShoeSizes = [
  { category: 'shoes', gender: 'men', eu: '38', uk: '5', us: '6', cm: '24.0' },
  { category: 'shoes', gender: 'men', eu: '39', uk: '6', us: '7', cm: '24.5' },
  { category: 'shoes', gender: 'men', eu: '40', uk: '6.5', us: '7.5', cm: '25.0' },
  { category: 'shoes', gender: 'men', eu: '41', uk: '7', us: '8', cm: '25.5' },
  { category: 'shoes', gender: 'men', eu: '42', uk: '8', us: '9', cm: '26.5' },
  { category: 'shoes', gender: 'men', eu: '43', uk: '9', us: '10', cm: '27.0' },
  { category: 'shoes', gender: 'men', eu: '44', uk: '9.5', us: '10.5', cm: '27.5' },
  { category: 'shoes', gender: 'men', eu: '45', uk: '10', us: '11', cm: '28.0' },
  { category: 'shoes', gender: 'men', eu: '46', uk: '11', us: '12', cm: '28.5' },
  { category: 'shoes', gender: 'men', eu: '47', uk: '12', us: '13', cm: '29.0' },
  { category: 'shoes', gender: 'men', eu: '48', uk: '13', us: '14', cm: '29.5' },
];

/** @type {ShoeSizeRow[]} */
export const womenShoeSizes = [
  { category: 'shoes', gender: 'women', eu: '35', uk: '2.5', us: '5', cm: '22.5' },
  { category: 'shoes', gender: 'women', eu: '36', uk: '3.5', us: '5.5', cm: '23.0' },
  { category: 'shoes', gender: 'women', eu: '37', uk: '4', us: '6', cm: '23.5' },
  { category: 'shoes', gender: 'women', eu: '38', uk: '5', us: '7', cm: '24.0' },
  { category: 'shoes', gender: 'women', eu: '39', uk: '6', us: '8', cm: '24.5' },
  { category: 'shoes', gender: 'women', eu: '40', uk: '6.5', us: '8.5', cm: '25.0' },
  { category: 'shoes', gender: 'women', eu: '41', uk: '7', us: '9', cm: '25.5' },
  { category: 'shoes', gender: 'women', eu: '42', uk: '8', us: '10', cm: '26.5' },
  { category: 'shoes', gender: 'women', eu: '43', uk: '9', us: '11', cm: '27.0' },
  { category: 'shoes', gender: 'women', eu: '44', uk: '9.5', us: '11.5', cm: '27.5' },
];

export function getShoeSizes(gender) {
  return gender === 'women' ? womenShoeSizes : menShoeSizes;
}
